var React = require('react');

function StarOfLife (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M2.14 155.72l32-55.43A16 16 0 0 1 56 94.43l184 106.43L424 94.42a16 16 0 0 1 21.86 5.84l32 55.43a16 16 0 0 1-5.86 21.87L288 284.19V496a16 16 0 0 1-16 16h-64a16 16 0 0 1-16-16V284.18L8 177.57a16 16 0 0 1-5.86-21.85z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M477.87 356.55l-32 55.43a16 16 0 0 1-21.87 5.86L240 311.41 56 417.85A16 16 0 0 1 34.15 412l-32-55.43A16 16 0 0 1 8 334.7l184-106.62V16.27a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v211.82L472 334.7a16 16 0 0 1 5.87 21.85z","className":"fa-primary","key":2})]);
}

StarOfLife.defaultProps = {"viewBox":"0 0 480 512","className":"icon"};

module.exports = StarOfLife;

StarOfLife.default = StarOfLife;
